module.exports = __webpack_public_path__ + "img/u536.8e8f5474.png";